module.exports = require ('./index.js').singleton.get;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/translate/singletone.js
 **/